import React, { useEffect } from "react";
import moment from "moment";
import { RESEARCH_TYPE } from "../utils/consts";
import englishJson from "../utils/language/leStudy/english.json";
import spanishJson from "../utils/language/leStudy/spanish.json";
import { useSelector, useDispatch } from "react-redux";
import { fetchLanguage } from "../../store/actions/languageActions";

const Footer = ({ formData }) => {
  // Fallback to English JSON if formData is not provided

  const dispatch = useDispatch();
  const { language, isLanguageLoaded } = useSelector((state) => state.language);  
  useEffect(() => {
    dispatch(fetchLanguage());
  }, [dispatch]);
  const dbFormData = RESEARCH_TYPE == "LE Study" ? (language == "English" ? englishJson : spanishJson) : englishJson;

  const data = formData || dbFormData;
  
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="footer-wrapper">
              <div className="left-side">
                <img src="./assets/images/eals-footer-logo.png" />
              </div>
              <div className="right-side">
                <p>
                  {data.page.footer.note}
                </p>
              </div>
            </div>
            <div className="footer-text">
              <p>
                © {moment().format("YYYY")} -
                {data.page.bottomFooter.version}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;